import script from "./HeaderUzafoundationSearchForm.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderUzafoundationSearchForm.vue?vue&type=script&setup=true&lang=js"

import "./HeaderUzafoundationSearchForm.vue?vue&type=style&index=0&id=799c9c46&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-799c9c46"]])

export default __exports__